<template>
  <t-default-layout active-nav-id="services">
    <div :class="componentClassName">
      <a-back-page :id="id" :text="backPageName()" :page="backPage()" :show="show" />
      <form ref="form" class="t-services-edit__form" enctype="multipart/form-data" @submit.prevent="handleFormSubmit">
        <div class="t-services-edit__fields">
          <m-section>
            <m-action-card
              :id="idName[1]"
              test-id-text="edit-services"
              title="詳細設定"
              :document-id="id"
              header-border
              no-header-margin
              icon="clock"
            >
              <div class="t-services-edit__fields">
                <div class="t-services-edit__row">
                  <div class="t-services-edit__form-col-1">
                    <div class="t-services-edit__fields">
                      <m-form-input id="t-services-edit-homeBubbleFlag__form-input">
                        <a-text id="t-services-edit-homeBubbleFlag__a-text">ホーム画面吹き出し</a-text>
                        <a-switch
                          id="t-services-edit-homeBubbleFlag"
                          v-model="servicesData.homeBubbleFlag"
                          data-testid="edit-services-priority-toggle-button"
                          @change="handleHomeBubbleFlag(servicesData.homeBubbleFlag)"
                        />
                      </m-form-input>
                    </div>
                  </div>
                  <div class="t-services-edit__form-col-2">
                    <div class="t-services-edit__bubble">
                      <a-apply-text-field
                        id="t-services-edit-homeBubbleComment"
                        v-model="servicesData.homeBubbleComment"
                        data-testid="edit-services-homeBubble-input"
                        type="text"
                        maxlength="6"
                        placeholder="ホーム画面の吹き出し入力"
                        :disabled="!servicesData.homeBubbleFlag"
                      />
                    </div>
                  </div>
                </div>
                <div id="t-services-edit-uploading-file" class="t-services-edit__row">
                  <div class="t-services-edit__col-1">
                    <div class="t-services-edit__fields">
                      <m-form-input>
                        <a-upload-field
                          id="upload-image"
                          v-model="servicesData.imageFile.file"
                          test-id-text="edit-services-image"
                          name="imageFile"
                          class="t-services-edit-uploading-file__form-upload"
                          label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                          accept="image/png, image/jpg, image/jpeg"
                          @change="handleUploadFileChange('imageFile', servicesData.imageFile.file)"
                          @show-error-modal="showErrorModal"
                        />
                      </m-form-input>
                      <m-form-input id="t-services-edit-abbreviated-name__form-input">
                        <a-text id="t-services-edit-abbreviated-name__a-text">略称表示</a-text>
                      </m-form-input>
                      <m-form-input id="t-services-add-info-bubbleFlag__form-input">
                        <a-text id="t-services-add-info-bubbleFlag__a-text">吹き出し</a-text>　　
                        <a-switch
                          id="t-services-add-bubbleFlag"
                          v-model="servicesData.bubbleFlag"
                          data-testid="add-bubbleFlag-detail-bubbleFlag-toggle-button"
                        />
                      </m-form-input>
                      <m-form-input id="t-services-add-info-serviceOverview__form-input">
                        <a-text id="t-services-add-info-serviceOverview__a-text">サービス概要</a-text>
                      </m-form-input>
                      <m-form-input id="t-services-add-info-contentsURL__form-input">
                        <a-text id="t-services-add-info-contentsURL__a-text">Webビュー</a-text>　　
                        <a-switch
                          id="t-services-add-webviewFlag"
                          v-model="servicesData.webviewFlag"
                          data-testid="add-webviewFlag-detail-bubbleFlag-toggle-button"
                        />
                      </m-form-input>
                    </div>
                  </div>
                  <div class="t-services-add__col-2">
                    <div class="t-services-add__fields">
                      <span id="t-services-edit-abbreviated-name__a-text">正式名称表示</span>
                      <m-form-input>
                        <a-apply-text-field
                          id="serviceName1"
                          v-model="servicesData.serviceName1"
                          data-testid="add-services-serviceName1-input"
                          type="text"
                          maxlength="10"
                          placeholder="サービス名1入力"
                        />
                      </m-form-input>
                    </div>
                    <m-form-input>
                      <a-apply-text-field
                        id="serviceName2"
                        v-model="servicesData.serviceName2"
                        data-testid="add-services-serviceName2-input"
                        type="text"
                        maxlength="10"
                        placeholder="サービス名2入力"
                      />
                    </m-form-input>
                    <div class="t-services-add__fields">
                      <m-form-input>
                        <a-apply-text-field
                          id="abbreviatedName"
                          v-model="servicesData.abbreviatedName"
                          data-testid="add-abbreviated-name-input"
                          type="text"
                          maxlength="15"
                          placeholder="略称表示入力"
                        />
                      </m-form-input>
                    </div>
                    <div class="t-services-add__fields">
                      <m-form-input>
                        <a-apply-text-field
                          id="bubbleComment"
                          v-model="servicesData.bubbleComment"
                          data-testid="add-services-bubbleComment-input"
                          type="text"
                          maxlength="10"
                          placeholder="吹き出しコメント入力"
                        />
                      </m-form-input>
                    </div>
                    <div class="t-services-add__fields">
                      <m-form-input>
                        <a-apply-text-field
                          id="serviceOverview"
                          v-model="servicesData.serviceOverview"
                          data-testid="add-services-serviceOverview-input"
                          type="text"
                          maxlength="30"
                          placeholder="サービス概要入力"
                        />
                      </m-form-input>
                    </div>
                    <m-form-input>
                      <a-apply-text-field
                        id="t-services-add__contents-url"
                        v-model="servicesData.contentsURL"
                        class="t-services-add__contents-url"
                        :disabled="disabled"
                        data-testid="t-services-add-url-input"
                        type="text"
                        maxlength="500"
                        placeholder="遷移先URL入力"
                      />
                    </m-form-input>
                  </div>
                </div>
              </div>
            </m-action-card>
          </m-section>

          <m-section>
            <m-action-card
              :id="idName[2]"
              title="サービス概要ページ"
              header-border
              no-header-margin
              icon="calendar-setting"
            >
              <div class="t-services-edit__fields">
                <div class="t-services-edit__row">
                  <a-text class="t-individual-level1__a-text">概要ページ</a-text>　
                  <m-form-input :id="'t-individual-radio'">
                    <a-radio
                      :id="'t-individual-true'"
                      v-model="servicesData.individualFlagStr"
                      value="need"
                      label="要"
                      @change="handleIndividualFlag(true)"
                    />
                    <a-radio
                      :id="'t-individual-false'"
                      v-model="servicesData.individualFlagStr"
                      value="noneed"
                      label="不要"
                      @change="handleIndividualFlag(false)"
                    />
                  </m-form-input>
                </div>
                <div v-show="servicesData.individualFlag">
                  <!-- サービスイメージ画像 -->
                  <div class="t-services-edit__row">
                    <div class="t-services-edit__col-features-1">
                      <m-form-input>
                        <a-text class="t-individual-level1__a-text">サービスイメージ画像</a-text>
                      </m-form-input>
                    </div>
                    <div class="t-services-edit__col-features-3">
                      <m-form-input>
                        <a-upload-field
                          v-model="servicesData.individualInfo.imageFile.file"
                          test-id-text="add-services-image"
                          name="imageFile"
                          class="t-services-edit-uploading-file"
                          label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                          accept="image/png, image/jpg, image/jpeg"
                          @change="handleUploadFileChangeImg(servicesData.individualInfo.imageFile)"
                          @show-error-modal="showErrorModal"
                        />
                      </m-form-input>
                    </div>
                  </div>
                  <!-- サービス概要 -->
                  <div class="t-services-edit__row">
                    <div class="t-services-edit__col-features-1">
                      <m-form-input>
                        <a-text class="t-individual-level1__a-text">サービス概要</a-text>
                      </m-form-input>
                    </div>
                    <div class="t-services-edit__col-features-3">
                      <m-rich-text-editor
                        id="description"
                        :html-content="servicesData.individualInfo.htmlContentDesc"
                        max-length="90"
                        @get-html-content="servicesData.individualInfo.htmlContentDesc = $event"
                        @get-text="servicesData.individualInfo.description = $event"
                      />
                    </div>
                  </div>
                  <!-- 料金説明 -->
                  <div class="t-services-edit__row">
                    <div class="t-services-edit__col-features-1">
                      <m-form-input>
                        <a-text class="t-individual-level1__a-text">料金説明</a-text>
                      </m-form-input>
                    </div>
                    <div class="t-services-edit__col-features-3">
                      <m-rich-text-editor
                        id="priceDescription"
                        :html-content="servicesData.individualInfo.htmlContentPrice"
                        max-length="90"
                        @get-html-content="servicesData.individualInfo.htmlContentPrice = $event"
                        @get-text="servicesData.individualInfo.priceDescription = $event"
                      />
                    </div>
                  </div>
                  <!-- 申込ページURL -->
                  <div class="t-services-edit__row">
                    <div class="t-services-edit__col-features-1">
                      <m-form-input>
                        <a-text class="t-individual-level1__a-text">申込ページURL</a-text>
                      </m-form-input>
                    </div>
                    <div class="t-services-edit__col-features-2">
                      <m-form-input>
                        <a-text class="t-individual-level1__a-text">Webビュー</a-text>　　
                        <a-switch
                          v-model="servicesData.individualInfo.appWebviewFlag"
                          class="t-individual-switch"
                          data-testid="add-webviewFlag-detail-bubbleFlag-toggle-button"
                        />
                      </m-form-input>
                      <m-form-input>
                        <a-text class="t-individual-level1__a-text">ログイン要求</a-text>　　
                        <a-switch
                          v-model="servicesData.individualInfo.appLoginFlag"
                          class="t-individual-switch"
                          data-testid="add-webviewFlag-detail-bubbleFlag-toggle-button"
                          @click="handleLoginCollaboration(servicesData.individualInfo.appLoginFlag)"
                        />
                      </m-form-input>
                    </div>
                    <div class="t-services-edit__col-features-3">
                      <m-form-input>
                        <a-apply-text-field
                          v-model="servicesData.individualInfo.appURL"
                          data-testid="add-services-serviceOverview-input"
                          type="text"
                          maxlength="500"
                          placeholder="遷移先URL"
                        />
                      </m-form-input>
                      <div v-if="servicesData.individualInfo.appLoginFlag">
                        <m-form-input>
                          <a-text class="t-individual-level1__a-text">アプリ申し込みページ連携</a-text>　　
                          <a-switch
                            v-model="servicesData.individualInfo.appCollaborationFlag"
                            class="t-individual-switch"
                            data-testid="add-webviewFlag-detail-bubbleFlag-toggle-button"
                          />
                        </m-form-input>
                      </div>
                    </div>
                  </div>
                  <!-- 利用者向けURL -->
                  <div class="t-services-edit__row">
                    <div class="t-services-edit__col-features-1">
                      <m-form-input>
                        <a-text class="t-individual-level1__a-text">ご利用中の方向けURL</a-text>
                      </m-form-input>
                    </div>
                    <div class="t-services-edit__col-features-2">
                      <m-form-input>
                        <a-text class="t-individual-level1__a-text">Webビュー</a-text>　　
                        <a-switch
                          v-model="servicesData.individualInfo.customerWebviewFlag"
                          class="t-individual-switch"
                          data-testid="add-webviewFlag-detail-bubbleFlag-toggle-button"
                        />
                      </m-form-input>
                      <m-form-input>
                        <a-text class="t-individual-level1__a-text">直接アクセス設定</a-text>　　
                        <a-switch
                          v-model="servicesData.individualInfo.customerAccessFlag"
                          class="t-individual-switch"
                          data-testid="add-webviewFlag-detail-bubbleFlag-toggle-button"
                        />
                      </m-form-input>
                    </div>
                    <div class="t-services-edit__col-features-3">
                      <m-form-input>
                        <a-apply-text-field
                          v-model="servicesData.individualInfo.customerURL"
                          data-testid="add-services-serviceOverview-input"
                          type="text"
                          maxlength="500"
                          placeholder="遷移先URL"
                        />
                      </m-form-input>
                    </div>
                  </div>
                  <!-- サービスの特徴 -->
                  <div class="t-services-edit__row">
                    <div class="t-services-edit__col-features-1">
                      <m-form-input>
                        <a-text class="t-individual-level1__a-text">サービスの特徴</a-text>
                      </m-form-input>
                    </div>
                  </div>
                  <div
                    v-for="(feature, index) in servicesData.individualInfo.features"
                    :key="index"
                    class="t-services-edit__fields"
                  >
                    <div class="t-services-edit__row">
                      <div class="t-services-edit__col-features-1">
                        <m-form-input>
                          <a-text class="t-individual-level2__a-text">特徴{{ index + 1 }}</a-text>
                        </m-form-input>
                      </div>
                      <div class="t-services-edit__col-features-2">
                        <m-form-input>
                          <a-upload-field
                            v-model="feature.imageFile.file"
                            name="imageFile"
                            class="t-services-edit-uploading-file"
                            label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                            accept="image/png, image/jpg, image/jpeg"
                            @change="handleUploadFileChangeImg(feature.imageFile)"
                            @show-error-modal="showErrorModal"
                          />
                        </m-form-input>
                      </div>
                      <div class="t-services-edit__col-features-3">
                        <!--  子カテゴリ削除ボタン-->
                        <a-button
                          v-if="index === servicesData.individualInfo.features.length - 1 && index > 0"
                          id="deleteBtn"
                          class="t-services-delete-feature"
                          variant="round"
                          size="small"
                          label="削除"
                          color="grey"
                          icon="trash"
                          icon-color="black"
                          :inline="true"
                          @click="handleDeleteFeature(index)"
                        />
                        <m-form-input v-if="index === 0">
                          <a-button
                            data-testid="services-add-features-button"
                            class="t-individual-add-button"
                            variant="icon"
                            color="primary"
                            icon="plus"
                            icon-color="white"
                            @click="handleAddFeature"
                          />
                          <span class="t-individual-add-button-red-text">特徴追加ボタン</span>
                        </m-form-input>
                        <div class="t-services-edit__fields">
                          <m-form-input>
                            <a-apply-text-field
                              id="t-service-add-feature-description{{ index }}"
                              v-model="feature.description"
                              data-testid="add-services-feature{{ index }}-input"
                              type="textarea"
                              rows="3"
                              maxlength="40"
                              placeholder="特徴説明"
                            />
                          </m-form-input>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- ご利用までの流れ -->
                  <!-- 左設置タブ -->
                  <div class="t-services-edit__row">
                    <div class="t-services-edit__col-features-1">
                      <m-form-input>
                        <a-text class="t-individual-level1__a-text">ご利用までの流れ<br />左設置タブ</a-text>
                      </m-form-input>
                    </div>
                  </div>
                  <div class="t-services-edit__row">
                    <div class="t-services-edit__col-features-1">
                      <m-form-input>
                        <a-text class="t-individual-level2__a-text">左タブ名</a-text>
                      </m-form-input>
                    </div>
                    <div class="t-services-edit__col-features-2">
                      <m-form-input>
                        <a-apply-text-field
                          id="t-services-edit-tab1-title"
                          v-model="servicesData.individualInfo.tabs[0].title"
                          data-testid="add-services--title-input"
                          type="text"
                          maxlength="10"
                          placeholder="左タブ名称"
                        />
                      </m-form-input>
                    </div>
                    <div class="t-services-edit__col-features-3">
                      <m-form-input>
                        <a-text class="t-individual-level2__a-text"></a-text>
                      </m-form-input>
                    </div>
                  </div>
                  <div v-for="(item, index) in servicesData.individualInfo.tabs[0].flow" :key="index">
                    <div class="t-services-edit__row t-services-edit__fields">
                      <div class="t-services-edit__col-features-1">
                        <m-form-input>
                          <a-text class="t-individual-level2__a-text">左タブ流れ{{ index + 1 }}</a-text>
                        </m-form-input>
                      </div>
                      <div class="t-services-edit__col-features-2">
                        <m-form-input>
                          <a-upload-field
                            v-model="item.imageFile.file"
                            test-id-text="add-services-image"
                            name="imageFile"
                            class="t-services-edit-uploading-file"
                            label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                            accept="image/png, image/jpg, image/jpeg"
                            @change="handleUploadFileChangeImg(item.imageFile)"
                            @show-error-modal="showErrorModal"
                          />
                        </m-form-input>
                      </div>
                      <div class="t-services-edit__col-features-3">
                        <!--  子カテゴリ削除ボタン-->
                        <a-button
                          v-if="index === servicesData.individualInfo.tabs[0].flow.length - 1 && index > 0"
                          id="deleteBtn"
                          class="t-services-delete-flow"
                          data-testid="t-support-delete-button"
                          variant="round"
                          size="small"
                          label="削除"
                          color="grey"
                          icon="trash"
                          icon-color="black"
                          :inline="true"
                          @click="handleDeleteFlow(0, index)"
                        />
                        <m-form-input v-if="index === 0">
                          <a-button
                            id="t-services-edit-tab1-flow-button"
                            data-testid="services-add-features-button"
                            class="t-individual-add-button"
                            variant="icon"
                            color="primary"
                            icon="plus"
                            icon-color="white"
                            @click="handleAddFlow(0)"
                          />
                          <span class="t-individual-add-button-red-text">左タブ流れ追加ボタン</span>
                        </m-form-input>
                        <div class="t-services-edit__fields">
                          <m-form-input>
                            <a-apply-text-field
                              id="t-service-add-tab1-flow{{ index }}-description"
                              v-model="item.description"
                              data-testid="add-services-tab1-flow{{ index }}-description-input"
                              type="textarea"
                              rows="3"
                              maxlength="40"
                              placeholder="流れ説明"
                            />
                          </m-form-input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 右タブ設置 -->
                  <div class="t-services-edit__row">
                    <div class="t-services-edit__col-features-1">
                      <m-form-input>
                        <a-text class="t-individual-level1__a-text">ご利用までの流れ<br />右設置タブ</a-text>
                      </m-form-input>
                    </div>

                    <div class="t-services-edit__col-features-3">
                      <m-form-input>
                        <a-text class="t-individual-level1__a-text">右タブ設置</a-text>　　
                        <a-switch
                          id="t-services-edit-rightTabFlag"
                          v-model="servicesData.individualInfo.rightTabFlag"
                          class="t-individual-switch"
                          data-testid="add-righttab-flag-toggle-button"
                          @change="handleRightTabFlag"
                        />
                      </m-form-input>
                    </div>
                  </div>
                  <div v-if="servicesData.individualInfo.rightTabFlag">
                    <div class="t-services-edit__row">
                      <div class="t-services-edit__col-features-1">
                        <m-form-input>
                          <a-text class="t-individual-level2__a-text">右タブ名</a-text>
                        </m-form-input>
                      </div>
                      <div class="t-services-edit__col-features-2">
                        <m-form-input>
                          <a-apply-text-field
                            id="t-services-edit-tab1-title"
                            v-model="servicesData.individualInfo.tabs[1].title"
                            data-testid="add-services-title-input"
                            type="text"
                            maxlength="10"
                            placeholder="右タブ名称"
                          />
                        </m-form-input>
                      </div>
                      <div class="t-services-edit__col-features-3">
                        <m-form-input>
                          <a-text class="t-individual-level2__a-text"></a-text>
                        </m-form-input>
                      </div>
                    </div>
                    <div v-for="(item, index) in servicesData.individualInfo.tabs[1].flow" :key="index">
                      <div class="t-services-edit__row t-services-edit__fields">
                        <div class="t-services-edit__col-features-1">
                          <m-form-input>
                            <a-text class="t-individual-level2__a-text">右タブ流れ{{ index + 1 }}</a-text>
                          </m-form-input>
                        </div>
                        <div class="t-services-edit__col-features-2">
                          <m-form-input>
                            <a-upload-field
                              v-model="item.imageFile.file"
                              name="imageFile"
                              class="t-services-edit-uploading-file"
                              label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                              accept="image/png, image/jpg, image/jpeg"
                              @change="handleUploadFileChangeImg(item.imageFile)"
                              @show-error-modal="showErrorModal"
                            />
                          </m-form-input>
                        </div>
                        <div class="t-services-edit__col-features-3">
                          <!--  子flow削除ボタン-->
                          <a-button
                            v-if="index === servicesData.individualInfo.tabs[1].flow.length - 1 && index > 0"
                            id="deleteBtn"
                            class="t-services-delete-flow"
                            data-testid="t-services-delete-button"
                            variant="round"
                            size="small"
                            label="削除"
                            color="grey"
                            icon="trash"
                            icon-color="black"
                            :inline="true"
                            @click="handleDeleteFlow(1, index)"
                          />

                          <m-form-input v-if="index === 0">
                            <a-button
                              id="t-services-edit-tab1-flow-button"
                              data-testid="services-add-features-button"
                              class="t-individual-add-button"
                              variant="icon"
                              color="primary"
                              icon="plus"
                              icon-color="white"
                              @click="handleAddFlow(1)"
                            />
                            <span class="t-individual-add-button-red-text">右タブ流れ追加ボタン</span>
                          </m-form-input>
                          <div class="t-services-edit__fields">
                            <m-form-input>
                              <a-apply-text-field
                                v-model="item.description"
                                data-testid="add-services-tab1-flow{{ index }}-description-input"
                                type="textarea"
                                rows="3"
                                maxlength="40"
                                placeholder="流れ説明"
                              />
                            </m-form-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- お問い合わせ -->
                  <div class="t-services-edit__row">
                    <div class="t-services-edit__col-features-1">
                      <m-form-input>
                        <a-text class="t-individual-level1__a-text">お問い合わせ</a-text>
                      </m-form-input>
                    </div>
                  </div>

                  <div v-if="!servicesData.individualInfo.inquiryFlag" class="t-services-edit__row">
                    <div class="t-services-edit__col-features-1">
                      <m-form-input>
                        <a-button
                          id="t-services-edit-support-button"
                          data-testid="services-add-support-button"
                          class="t-individual-add-button"
                          variant="icon"
                          color="primary"
                          icon="plus"
                          icon-color="white"
                          @click="handleInquiryAdd"
                        />
                        <span class="t-individual-add-button-red-text">大カテゴリ追加ボタン</span>
                      </m-form-input>
                    </div>
                  </div>
                  <div v-if="servicesData.individualInfo.inquiryFlag" class="t-services-edit__inquiry">
                    <div class="t-services-add__fields">
                      <div id="t-services-add__fields__support" class="t-services-add__fields__support">
                        <a-text id="t-services-add__fields__a-text-top">●</a-text>
                        <a-text id="t-services-add__fields__support__a-text">大カテゴリ1</a-text>
                        <a-button
                          id="deleteBtn"
                          class="t-support-delete-category"
                          data-testid="t-support-delete-button"
                          variant="round"
                          size="small"
                          label="削除"
                          color="grey"
                          icon="trash"
                          icon-color="black"
                          :inline="true"
                          @click="handleInquiryDelete"
                        />
                      </div>
                    </div>
                    <div class="t-services-add__fields">
                      <div class="t-services-add__row">
                        <a-text id="t-services-add-support__a-text">大カテゴリ名1</a-text>　
                        <m-form-input id="t-services-add__pushtype">
                          <a-apply-text-field
                            :id="'mainCategoryName' + index"
                            v-model="servicesData.individualInfo.inquiry.mainCategoryName"
                            class="t"
                            :data-testid="'add-services-mainCategoryName-input' + index"
                            type="text"
                            maxlength="50"
                            :placeholder="`大カテゴリ名1入力`"
                          />
                        </m-form-input>
                      </div>
                    </div>
                    <div
                      v-for="(subCategory, subIndex) in servicesData.individualInfo.inquiry.subCategories"
                      :key="subIndex"
                    >
                      <div class="t-services-add__fields">
                        <div id="t-services-add__fields__support" class="t-services-add__fields__support">
                          <a-text id="t-services-add__fields__a-text-top">●</a-text>
                          <a-text id="t-services-add__fields__support__a-text">小カテゴリ{{ subIndex + 1 }}</a-text>
                          <a-button
                            v-if="subIndex === 0"
                            id="t-services-add-support-button"
                            data-testid="services-add-support-button"
                            class="t-supprt-subcategory-add"
                            variant="icon"
                            color="primary"
                            icon="plus"
                            icon-color="white"
                            @click="handleAddSubForInquiry"
                          />
                          <span v-if="subIndex === 0" class="t-add-button-method-red-text">小カテゴリ追加ボタン</span>
                          <!--  子カテゴリ削除ボタン-->
                          <a-button
                            v-if="subIndex > 0"
                            id="deleteBtn"
                            class="t-support-delete-category"
                            data-testid="t-support-delete-button"
                            variant="round"
                            size="small"
                            label="削除"
                            color="grey"
                            icon="trash"
                            icon-color="black"
                            :inline="true"
                            @click="handleDeleteSubForInquiry(subIndex)"
                          />
                        </div>
                      </div>
                      <div class="t-services-add__fields">
                        <div class="t-services-add__row">
                          <a-text id="t-services-add-support__a-text">小カテゴリ名{{ subIndex + 1 }}</a-text
                          >　
                          <m-form-input id="t-services-add__pushtype">
                            <a-apply-text-field
                              id="subCategoriesName"
                              v-model="subCategory.name"
                              class="t-services-add__pushtype"
                              data-testid="add-services-subCategoryName-input"
                              type="text"
                              maxlength="50"
                              :placeholder="`小カテゴリ名${subIndex + 1}入力`"
                            />
                          </m-form-input>
                        </div>
                        <div class="t-services-add__row">
                          <a-text id="t-services-add-support__a-text">お問い合わせ種類</a-text>　
                          <m-form-input :id="'t-support-radio' + index + subIndex">
                            <a-radio
                              v-model="subCategory.contactType"
                              class="t-support-link"
                              :disabled="disabled"
                              :data-testid="'t-support-link' + subIndex"
                              value="link"
                              label="外部リンク"
                              @change="setDefaultContactMethodLinkForInquiry(subIndex)"
                            />
                            <a-radio
                              v-model="subCategory.contactType"
                              class="t-services-button"
                              :disabled="disabled"
                              :data-testid="'t-support-button' + subIndex"
                              value="button"
                              label="ボタン"
                              @change="setDefaultContactMethodForInquiry(subIndex)"
                            />
                          </m-form-input>
                        </div>
                        <div v-if="subCategory.contactType === 'button'" class="t-services-add__row">
                          <a-text id="t-services-add-support__a-text"
                            >補足説明&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a-text
                          >　
                          <m-form-input id="t-services-add__pushtype">
                            <a-apply-text-field
                              id="description"
                              v-model="subCategory.description"
                              class="t-services-add__pushtype"
                              data-testid="add-services-description-input"
                              type="text"
                              maxlength="50"
                              placeholder="フリーテキスト（様々なパターンありそうなため）"
                            />
                          </m-form-input>
                        </div>
                        <div class="t-services-add__row">
                          <m-form-input v-if="subCategory.contactType === 'link'">
                            <a-apply-text-field
                              id="t-support-url"
                              v-model="subCategory.contactInfo[0].target"
                              class="m-form-input__content"
                              :disabled="disabled"
                              :data-testid="'add-support-url-input-for-inquiry' + subIndex"
                              type="text"
                              maxlength="500"
                              placeholder="URLを入力"
                            />
                          </m-form-input>
                        </div>
                        <div v-if="subCategory.contactType === 'button'">
                          <div v-for="(method, methodIndex) in subCategory.contactInfo" :key="methodIndex">
                            <div class="t-services-add__row">
                              <a-text id="t-services-add-method__a-text">お問い合わせ方法{{ methodIndex + 1 }} </a-text
                              >　
                              <a-button
                                v-if="methodIndex === 0"
                                id="t-services-add-method-button"
                                data-testid="services-add-method-button-for-inquiry"
                                variant="icon"
                                color="primary"
                                icon="plus"
                                icon-color="white"
                                @click="handleAddMethodForInquiry(subCategory)"
                              />
                              <span v-if="methodIndex === 0" class="t-add-button-method-red-text"
                                >問合せ追加ボタン</span
                              >
                              <!--  削除ボタン-->
                              <a-button
                                v-if="methodIndex > 0"
                                id="deleteBtn"
                                data-testid="t-support-delete-button-for-inquery"
                                variant="round"
                                size="small"
                                label="削除"
                                color="grey"
                                icon="trash"
                                icon-color="black"
                                :inline="true"
                                @click="handleDeleteMethodForInquiry(subIndex, methodIndex)"
                              />
                            </div>
                            <div class="t-services-add__row t-support-contact">
                              <a-radio
                                id="t-support-button-mail"
                                v-model="method.method"
                                class="t-support-button-mail"
                                :disabled="disabled"
                                :name="'methodContactForInquiry' + subIndex + methodIndex"
                                :data-testid="'t-support-button-for-inquery' + subIndex"
                                value="mail"
                                label="メールでお問い合わせ"
                              />
                              <a-radio
                                id="t-support-button-phone"
                                v-model="method.method"
                                class="t-support-button-phone"
                                :disabled="disabled"
                                :name="'methodContacForInquiry' + subIndex + methodIndex"
                                :data-testid="'t-support-button-phone-for-inquery' + subIndex"
                                value="phone"
                                label="電話でお問い合わせ"
                              />
                              <a-radio
                                id="t-support-button-form"
                                v-model="method.method"
                                class="t-support-button-form"
                                :disabled="disabled"
                                :name="'methodContactForInquery' + subIndex + methodIndex"
                                :data-testid="'t-support-button-phone-for-inquery' + subIndex"
                                value="form"
                                label="フォームでお問い合わせ"
                              />
                              <a-radio
                                id="t-support-button-shop"
                                v-model="method.method"
                                class="t-support-button-shop"
                                :disabled="disabled"
                                :name="'methodContactForInquery' + subIndex + methodIndex"
                                :data-testid="'t-support-button-shop-for-inquery' + subIndex"
                                value="shop"
                                label="ドコモショップでお問い合わせ"
                              />
                            </div>
                            <div class="t-services-add__row">
                              <m-form-input>
                                <a-apply-text-field
                                  id="t-support-url"
                                  v-model="method.target"
                                  class="t-add-method"
                                  :disabled="disabled"
                                  :data-testid="'add-target-input-for-inquery' + subIndex + methodIndex"
                                  type="text"
                                  maxlength="500"
                                  placeholder="メールアドレスor電話番号orURLを入力"
                                />
                              </m-form-input>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-action-card
            :id="idName[3]"
            title="サポートページ
"
            header-border
            no-header-margin
            icon="calendar-setting"
          >
            <template #action>
              <a-button
                id="t-services-add-support-button"
                data-testid="services-add-support-button"
                class="t-services-add-support-heading-item"
                variant="icon"
                color="primary"
                icon="plus"
                icon-color="white"
                @click="handleSupportAdd"
              />
              <span class="t-add-button-support-red-text">大カテゴリ追加ボタン</span>
            </template>
            <!-- サポート情報がある確認 -->
            <div v-if="servicesData.supportInfo.length > 0">
              <div
                v-for="(support, index) in servicesData.supportInfo"
                id="t-services-add-homeBubbleFlag__form-input"
                :key="index"
              >
                <div class="t-services-add__fields">
                  <div id="t-services-add__fields__support" class="t-services-add__fields__support">
                    <a-text id="t-services-add__fields__a-text-top">●</a-text>
                    <a-text id="t-services-add__fields__support__a-text">大カテゴリ{{ index + 1 }}</a-text>
                    <a-button
                      id="deleteBtn"
                      class="t-support-delete-category"
                      data-testid="t-support-delete-button"
                      variant="round"
                      size="small"
                      label="削除"
                      color="grey"
                      icon="trash"
                      icon-color="black"
                      :inline="true"
                      @click="handleDeleteSupport(index)"
                    />
                  </div>
                </div>
                <div class="t-services-add__fields">
                  <div class="t-services-add__row">
                    <a-text id="t-services-add-support__a-text">大カテゴリ名{{ index + 1 }}</a-text
                    >　
                    <m-form-input id="t-services-add__pushtype">
                      <a-apply-text-field
                        :id="'mainCategoryName' + index"
                        v-model="servicesData.supportInfo[index].mainCategoryName"
                        class="t"
                        :data-testid="'add-services-mainCategoryName-input' + index"
                        type="text"
                        maxlength="50"
                        :placeholder="`大カテゴリ名${index + 1}入力`"
                      />
                    </m-form-input>
                  </div>
                </div>
                <div v-for="(subCategory, subIndex) in support.subCategories" :key="subIndex">
                  <div class="t-services-add__fields">
                    <div id="t-services-add__fields__support" class="t-services-add__fields__support">
                      <a-text id="t-services-add__fields__a-text-top">●</a-text>
                      <a-text id="t-services-add__fields__support__a-text">小カテゴリ{{ subIndex + 1 }}</a-text>
                      <a-button
                        v-if="subIndex === 0"
                        id="t-services-add-support-button"
                        data-testid="services-add-support-button"
                        class="t-supprt-subcategory-add"
                        variant="icon"
                        color="primary"
                        icon="plus"
                        icon-color="white"
                        @click="handleAddSubcategory(index)"
                      />
                      <span v-if="subIndex === 0" class="t-add-button-method-red-text">小カテゴリ追加ボタン</span>
                      <!--  子カテゴリ削除ボタン-->
                      <a-button
                        v-if="subIndex > 0"
                        id="deleteBtn"
                        class="t-support-delete-category"
                        data-testid="t-support-delete-button"
                        variant="round"
                        size="small"
                        label="削除"
                        color="grey"
                        icon="trash"
                        icon-color="black"
                        :inline="true"
                        @click="handleDeleteSub(index, subIndex)"
                      />
                    </div>
                  </div>
                  <div class="t-services-add__fields">
                    <div class="t-services-add__row">
                      <a-text id="t-services-add-support__a-text">小カテゴリ名{{ subIndex + 1 }}</a-text
                      >　
                      <m-form-input id="t-services-add__pushtype">
                        <a-apply-text-field
                          id="subCategoriesName"
                          v-model="subCategory.name"
                          class="t-services-add__pushtype"
                          data-testid="add-services-subCategoryName-input"
                          type="text"
                          maxlength="50"
                          :placeholder="`小カテゴリ名${subIndex + 1}入力`"
                        />
                      </m-form-input>
                    </div>
                    <div class="t-services-add__row">
                      <a-text id="t-services-add-support__a-text">お問い合わせ種類</a-text>　
                      <m-form-input :id="'t-support-radio' + index + subIndex">
                        <a-radio
                          :id="'t-support-link' + index + subIndex"
                          v-model="subCategory.contactType"
                          class="t-support-link"
                          :disabled="disabled"
                          :name="'contactSelectLink' + index + subIndex"
                          :data-testid="'t-support-link' + subIndex"
                          value="link"
                          label="外部リンク"
                          @change="setDefaultContactMethodLink(index, subIndex)"
                        />
                        <a-radio
                          :id="'t-support-button' + index + subIndex"
                          v-model="subCategory.contactType"
                          class="t-services-button"
                          :disabled="disabled"
                          :name="'contactSelectButton' + index + subIndex"
                          :data-testid="'t-support-button' + subIndex"
                          value="button"
                          label="ボタン"
                          @change="setDefaultContactMethod(index, subIndex)"
                        />
                      </m-form-input>
                    </div>
                    <div v-if="subCategory.contactType === 'button'" class="t-services-add__row">
                      <a-text id="t-services-add-support__a-text"
                        >補足説明&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a-text
                      >　
                      <m-form-input id="t-services-add__pushtype">
                        <a-apply-text-field
                          id="description"
                          v-model="subCategory.description"
                          class="t-services-add__pushtype"
                          data-testid="add-services-description-input"
                          type="text"
                          maxlength="50"
                          placeholder="フリーテキスト（様々なパターンありそうなため）"
                        />
                      </m-form-input>
                    </div>
                    <div class="t-services-add__row">
                      <m-form-input v-if="subCategory.contactType === 'link'">
                        <a-apply-text-field
                          id="t-support-url"
                          v-model="subCategory.contactInfo[0].target"
                          class="m-form-input__content"
                          :disabled="disabled"
                          :data-testid="'add-support-url-input' + subIndex"
                          type="text"
                          maxlength="500"
                          placeholder="URLを入力"
                        />
                      </m-form-input>
                    </div>
                    <div v-if="subCategory.contactType === 'button'">
                      <div v-for="(method, methodIndex) in subCategory.contactInfo" :key="methodIndex">
                        <div class="t-services-add__row">
                          <a-text id="t-services-add-method__a-text">お問い合わせ方法{{ methodIndex + 1 }} </a-text>　
                          <a-button
                            v-if="methodIndex === 0"
                            id="t-services-add-method-button"
                            data-testid="services-add-method-button"
                            variant="icon"
                            color="primary"
                            icon="plus"
                            icon-color="white"
                            @click="handleAddMethod(subCategory)"
                          />
                          <span v-if="methodIndex === 0" class="t-add-button-method-red-text"
                            >お問い合わせ追加ボタン</span
                          >
                          <!--  子カテゴリ削除ボタン-->
                          <a-button
                            v-if="methodIndex > 0"
                            id="deleteBtn"
                            data-testid="t-support-delete-button"
                            variant="round"
                            size="small"
                            label="削除"
                            color="grey"
                            icon="trash"
                            icon-color="black"
                            :inline="true"
                            @click="handleDeleteMethod(index, subIndex, methodIndex)"
                          />
                        </div>
                        <div class="t-services-add__row t-support-contact">
                          <a-radio
                            id="t-support-button-mail"
                            v-model="method.method"
                            class="t-support-button-mail"
                            :disabled="disabled"
                            :name="'methodContact' + index + subIndex + methodIndex"
                            :data-testid="'t-support-button' + subIndex"
                            value="mail"
                            label="メールでお問い合わせ"
                          />
                          <a-radio
                            id="t-support-button-phone"
                            v-model="method.method"
                            class="t-support-button-phone"
                            :disabled="disabled"
                            :name="'methodContact' + index + subIndex + methodIndex"
                            :data-testid="'t-support-button-phone' + subIndex"
                            value="phone"
                            label="電話でお問い合わせ"
                          />
                          <a-radio
                            id="t-support-button-form"
                            v-model="method.method"
                            class="t-support-button-form"
                            :disabled="disabled"
                            :name="'methodContact' + index + subIndex + methodIndex"
                            :data-testid="'t-support-button-phone' + subIndex"
                            value="form"
                            label="フォームでお問い合わせ"
                          />
                          <a-radio
                            id="t-support-button-shop"
                            v-model="method.method"
                            class="t-support-button-shop"
                            :disabled="disabled"
                            :name="'methodContact' + index + subIndex + methodIndex"
                            :data-testid="'t-support-button-shop' + subIndex"
                            value="shop"
                            label="ドコモショップでお問い合わせ"
                          />
                        </div>
                        <div class="t-services-add__row">
                          <m-form-input>
                            <a-apply-text-field
                              id="t-support-url"
                              v-model="method.target"
                              class="t-add-method"
                              :disabled="disabled"
                              :data-testid="'add-target-input' + index + subIndex + methodIndex"
                              type="text"
                              maxlength="500"
                              placeholder="メールアドレスor電話番号orURLを入力"
                            />
                          </m-form-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </m-action-card>
          <m-section>
            <m-action-card :id="idName[4]" title="公開設定" header-border no-header-margin icon="calendar-setting">
              <div class="t-services-edit__fields">
                <div id="t-services-edit-cast-start-date-day__row" class="t-services-edit__row">
                  <a-text id="t-services-edit-cast-start-date__a-text">公開日</a-text>　
                  <m-form-input id="t-services-edit-cast-start-date-day__form-input">
                    <a-calendar-field
                      id="cast-start-date-day"
                      v-model="servicesData.castStartDate"
                      test-id-text="edit-services-publish-start"
                      :min-date="minDate"
                      date-placeholder="公開日"
                      time-placeholder="00:00"
                      mode="dateTime"
                      :disabled="hasParentDoc"
                    />
                  </m-form-input>
                </div>
                <div class="t-services-edit__row">
                  <a-text id="t-services-edit-cast-end-date__a-text">公開終了日</a-text>　
                  <m-form-input id="t-services-edit-cast-end-date-day__form-input">
                    <a-calendar-field
                      id="cast-end-date-day"
                      v-model="servicesData.castEndDate"
                      test-id-text="edit-services-publish-end"
                      :min-date="minDate"
                      date-placeholder="公開終了日"
                      time-placeholder="00:00"
                      mode="dateTime"
                      @change="handleChange"
                    />
                  </m-form-input>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[5]" title="承認フロー" header-border no-header-margin icon="user-setting">
              <div class="t-services-edit__fields__pushtype">
                <m-form-input id="t-services-edit__fields__pushtype">
                  <a-select-field
                    id="t-services-edit__fields__pushtype__a-select-field"
                    v-model="servicesData.checkStatus"
                    data-testid="detail-services-check-status-select"
                    :options="checkStatusOptions"
                    :v-options="visibleCheckStatusOptions"
                  />
                </m-form-input>
              </div>
              <!-- 情報を表示するために m-data-table を追加します 承認フロー -->
              <m-data-table
                :empty-text="dataTableEmp"
                :fit="true"
                :data="servicesData.checkHistories"
                id-text="services-check-histories-info-display"
              >
                <a-data-table-column
                  prop="publishedDocumentId"
                  :min-width="120"
                  :label="'公開ドキュメントID：<br>' + docId"
                  align="center"
                >
                  <template #default="scope">
                    <a-text size="medium" :center="true">公開{{ scope.index + 1 }}回目</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="draft" :min-width="100" label="下書き" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.draft.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.draft.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="checked" :min-width="100" label="チェック済み" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.checked.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.checked.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="approved" :min-width="100" label="承認済み" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.approved.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.approved.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
              </m-data-table>
            </m-action-card>
          </m-section>
        </div>
        <m-form-action-buttons>
          <a-button id="saveBtn" data-testid="edit-services-save-button" variant="block" color="primary" submit="submit"
            >保存</a-button
          >
        </m-form-action-buttons>
      </form>
    </div>

    <!-- Info, Erro Modal -->
    <teleport to="body">
      <o-modal
        id="online-shop-bannersCreate_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal--confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            data-testid="error-info-modal-confirm-button"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseModal"
          />
        </template>
      </o-modal>
    </teleport>
  </t-default-layout>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import ASwitch from '@/components/atoms/switch';
import AUploadField from '@/components/atoms/upload-field';
import AText from '@/components/atoms/text';
import ABackPage from '@/components/atoms/back-page';
import AApplyTextField from '@/components/atoms/apply-text-field';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import TDefaultLayout from '@/components/templates/default-layout';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import ACalendarField from '@/components/atoms/calendar-field';
import { utils } from '@/common/utils.js';
import { useVuelidate } from '@vuelidate/core';
import { servicesValidation } from '@/validations/services.js';
import { cloneDeep } from 'lodash';
import MRichTextEditor from '@/components/molecules/rich-text-editor';

export default {
  name: 't-services-edit',
  components: {
    TDefaultLayout,
    MSection,
    MActionCard,
    AText,
    AButton,
    ABackPage,
    MFormActionButtons,
    ASwitch,
    AUploadField,
    ACalendarField,
    AApplyTextField,
    MRichTextEditor,
  },
  mixins: [customRequest, customValidate, messageContent, utils],
  props: {
    class: {
      type: String,
      default: '',
    },
  },

  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  data() {
    return {
      id: this.$route.query.id,
      source: this.$route.query.source,
      execUserID: this.$store.state.user.userID,
      show: this.$route.query.show ?? '1',
      idName: [],
      maxPosition: 0,
      minDate: utils.currentDateTime(),
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      hasParentDoc: false,
      docId: (() => {
        const id = this.$route.query.id;
        if (id.includes('_')) {
          const lastIndex = id.lastIndexOf('_');
          return id.slice(0, lastIndex);
        }
        return id;
      })(),

      // コンテンツデータ
      servicesData: {
        supportInfo: [
          {
            mainCategoryName: '', // カテゴリのメイン名
            subCategories: [
              {
                name: '', // 子カテゴリ名
                description: '', // 詳細
                contactType: '',
                contactInfo: [
                  {
                    method: '',
                    target: '',
                  },
                ],
              },
            ],
          },
        ],
        serviceName1: '', // サービス名1
        serviceName2: '', // サービス名2
        abbreviatedName: '', // 略称表示
        serviceOverview: '', // サービス概要
        imageURL: '', //
        position: 0, // 位置表示
        imageFile: {
          file: null,
          filename: null,
          binary: null,
          size: null,
        },
        homeBubbleFlag: false, // ホーム画面NEW吹き出し
        homeBubbleComment: '', // ホーム画面吹き出し
        webviewFlag: false, // Webビュー
        bubbleFlag: false, // 吹き出しフラグ
        bubbleComment: '', // 吹き出しコメント
        castStartDate: '', // 公開開始日
        castEndDate: '', // 公開終了日
        deleteDate: '', // 削除予定日
        draftFlag: false, // 下書き
        checkStatus: 'draft', // チェックステータス
        contentsURL: '',
        individualFlagStr: 'noneed', // 概要ページフラグ
        individualInfo: {
          imageURL: '', // サービスイメージ画像
          imageFile: {
            file: null,
            filename: null,
            binary: null,
            size: null,
          },
          htmlContentDesc: '', // サービス概要ページのサービス概要(HTMLフォーマット)
          htmlContentPrice: '', // サービス概要ページの料金説明(HTMLフォーマット)
          description: '', // サービス概要
          priceDescription: '', // 料金説明
          appWebviewFlag: false, // 申し込みページのwebviewフラグ
          appURL: '', // 申込ページのURL
          appLoginFlag: false, // 申込ページのログイン要求
          appCollaborationFlag: false, // アプリ申し込みページ連携
          customerWebviewFlag: false, // ご利用中の遷移先のwebviewフラグ
          customerURL: '', // ご利用中の方向けURL
          customerAccessFlag: false, // 直接アクセス設定
          // サービスの特徴
          features: [
            {
              imageURL: '',
              imageFile: {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
              description: '',
            },
          ],
          // ご利用までの流れ
          rightTabFlag: false, // 右設置タブ有無
          tabs: [
            {
              title: '',
              flow: [
                {
                  imageURL: '',
                  imageFile: {
                    file: null,
                    filename: null,
                    binary: null,
                    size: null,
                  },
                  description: '',
                },
              ],
            },
          ],
          // お問い合わせ
          inquiryFlag: false, // お問い合わせ有無
          inquiry: {
            mainCategoryName: '', // カテゴリのメイン名
            subCategories: [
              {
                name: '', // 子カテゴリ名
                contactType: 'link',
                description: '', // 詳細
                contactInfo: [
                  {
                    method: 'link',
                    target: '',
                  },
                ],
              },
            ],
          },
        },
        checkHistories: [
          {
            draft: {
              userName: '',
              updateDate: '',
            },
            checked: {
              userName: '',
              updateDate: '',
            },
            approved: {
              userName: '',
              updateDate: '',
            },
          },
        ],
      },
      isPublished: false, // 公開中かどうかのフラグ
      beforeCastEndDate: '', // 変更前の公開終了日時
      currentCheckStatus: 'draft', // DBに現在のcheckStatus
      checkStatusOptions: [
        { value: 'draft', label: '下書き' },
        { value: 'checked', label: 'チェック済み' },
        { value: 'approved', label: '承認済み' },
      ],
      visibleCheckStatusOptions: [],
    };
  },

  validations() {
    return servicesValidation.update(
      this.servicesData.checkStatus,
      this.servicesData.bubbleFlag,
      this.servicesData.supportInfo
    );
  },

  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-services-edit');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  created() {
    for (let i = 1; i <= 5; i++) {
      this.idName[i] = 'h1-services-edit-' + i;
    }
    this.handleGetServicesInfo();
    this.getPositionServicesList();
  },
  mounted() {},
  methods: {
    handleLoginCollaboration(flag) {
      if (flag === false) {
        this.servicesData.individualInfo.appCollaborationFlag = false;
      }
    },
    handleHomeBubbleFlag(flag) {
      if (flag === false) {
        this.servicesData.homeBubbleComment = '';
      }
    },
    handleIndividualFlag(flag) {
      this.servicesData.individualFlag = flag;
    },
    setDefaultContactMethodForInquiry(subIndex) {
      if (this.servicesData.individualInfo.inquiry.subCategories[subIndex].contactType === 'button') {
        this.servicesData.individualInfo.inquiry.subCategories[subIndex].contactInfo = [{ method: 'mail', target: '' }];
      }
    },
    setDefaultContactMethodLinkForInquiry(subIndex) {
      if (this.servicesData.individualInfo.inquiry.subCategories[subIndex].contactType === 'link') {
        this.servicesData.individualInfo.inquiry.subCategories[subIndex].contactInfo = [{ method: 'link', target: '' }];
      }
    },
    setDefaultContactMethod(index, subIndex) {
      if (this.servicesData.supportInfo[index].subCategories[subIndex].contactType === 'button') {
        this.servicesData.supportInfo[index].subCategories[subIndex].contactInfo = [{ method: 'mail', target: '' }];
      }
    },
    setDefaultContactMethodLink(index, subIndex) {
      if (this.servicesData.supportInfo[index].subCategories[subIndex].contactType === 'link') {
        this.servicesData.supportInfo[index].subCategories[subIndex].contactInfo = [{ method: 'link', target: '' }];
      }
    },
    async handleFormSubmit() {
      const isFormCorrect = await this.v$.$validate();

      if (!isFormCorrect) {
        let errMsg = '';
        this.v$.$errors.map(item => (errMsg += item.$message + '<br>'));
        this.showErrorModal(errMsg);
        return;
      }

      const payload = cloneDeep(this.servicesData);
      const htmlContentDesc = payload.individualInfo.htmlContentDesc;
      const htmlContentPrice = payload.individualInfo.htmlContentPrice;

      // htmlContentDesc と htmlContentPriceの文字禁止を確認する
      const hasDescError = messageContent.validateHtmlContentUrls(
        htmlContentDesc,
        this.showErrorModal,
        messageContent.urlSpecialCharater
      );
      const hasPriceError = messageContent.validateHtmlContentUrls(
        htmlContentPrice,
        this.showErrorModal,
        messageContent.urlSpecialCharater
      );
      if (hasDescError || hasPriceError) {
        return;
      }
      //  URLに特殊文字　<>'"　を入力するチェックする
      if (messageContent.checkUrlSpecialCharacter(payload.contentsURL)) {
        this.showErrorModal(messageContent.urlSpecialCharater);
        return;
      }

      //  targetに特殊文字　<>'"　を入力するチェックする
      for (const info of payload.supportInfo) {
        for (const subCategory of info.subCategories) {
          for (const contact of subCategory.contactInfo) {
            if (messageContent.checkUrlSpecialCharacter(contact.target)) {
              this.showErrorModal(messageContent.urlSpecialCharater);
              return;
            }
          }
        }
      }
      //  appURL,customerURLに特殊文字　<>'"　を入力するチェックする
      if (
        messageContent.checkUrlSpecialCharacter(payload.individualInfo.appURL) ||
        messageContent.checkUrlSpecialCharacter(payload.individualInfo.customerURL)
      ) {
        this.showErrorModal(messageContent.urlSpecialCharater);
        return;
      }
      for (const subCategory of payload.individualInfo.inquiry.subCategories) {
        for (const contact of subCategory.contactInfo) {
          if (messageContent.checkUrlSpecialCharacter(contact.target)) {
            this.showErrorModal(messageContent.urlSpecialCharater);
            return;
          }
        }
      }

      payload.contentsURL = encodeURI(payload.contentsURL);
      payload.individualInfo.appURL = encodeURI(payload.individualInfo.appURL);
      payload.individualInfo.customerURL = encodeURI(payload.individualInfo.customerURL);
      // Note: 「=」はCloudArmorポリシーに抵触するケースがあるためエスケープを行う
      payload.homeBubbleComment = payload.homeBubbleComment.replace(/=/g, '%%eq%%');
      payload.serviceName1 = payload.serviceName1.replace(/=/g, '%%eq%%');
      payload.serviceName2 = payload.serviceName2.replace(/=/g, '%%eq%%');
      payload.serviceOverview = payload.serviceOverview.replace(/=/g, '%%eq%%');
      payload.abbreviatedName = payload.abbreviatedName.replace(/=/g, '%%eq%%');
      payload.individualInfo.description = payload.individualInfo.description.replace(/=/g, '%%eq%%');
      payload.individualInfo.priceDescription = payload.individualInfo.priceDescription.replace(/=/g, '%%eq%%');

      // Note: htmlコンテンツは不要なタグの削除
      payload.individualInfo.htmlContentDesc = utils.processHtmlContent(payload.individualInfo.htmlContentDesc);
      payload.individualInfo.htmlContentPrice = utils.processHtmlContent(payload.individualInfo.htmlContentPrice);

      for (const info of payload.individualInfo.features) {
        info.description = info.description.replace(/=/g, '%%eq%%');
      }
      for (const info of payload.individualInfo.tabs) {
        for (const tab of info.flow) {
          tab.description = tab.description.replace(/=/g, '%%eq%%');
        }
      }
      for (const info of payload.individualInfo.inquiry.subCategories) {
        info.description = info.description.replace(/=/g, '%%eq%%');
      }

      for (const info of payload.supportInfo) {
        for (const subCategory of info.subCategories) {
          for (const contact of subCategory.contactInfo) {
            contact.target = encodeURI(contact.target);
          }
        }
      }
      if (!messageContent.checkHasSpecialCharacterInObj(payload)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return;
      }

      const id = this.id;
      if (id) {
        if (this.servicesData.castEndDate) {
          const castEndDate = new Date(this.servicesData.castEndDate);
          const deleteDate = new Date(castEndDate.setFullYear(castEndDate.getFullYear() + 1));
          this.deleteDate = this.convertDateToString(deleteDate);
        }
        const formDataTmp = {
          id: id ?? '',
          serviceName1: payload.serviceName1 ?? '',
          serviceName2: payload.serviceName2 ?? '',
          abbreviatedName: payload.abbreviatedName ?? '',
          serviceOverview: this.servicesData.serviceOverview ?? '',
          imageFile: this.servicesData.imageFile.binary ?? '',
          position: this.maxPosition ?? 0,
          homeBubbleFlag: this.servicesData.homeBubbleFlag ?? false,
          homeBubbleComment: this.servicesData.homeBubbleComment ?? '',
          bubbleFlag: this.servicesData.bubbleFlag ?? false,
          bubbleComment: this.servicesData.bubbleComment ?? '',
          castStartDate: this.servicesData.castStartDate ?? '',
          castEndDate: this.servicesData.castEndDate ?? '',
          deleteDate: this.deleteDate ?? '',
          draftFlag: this.servicesData.draftFlag ?? false,
          webviewFlag: this.servicesData.webviewFlag ?? false,
          checkStatus: this.servicesData.checkStatus ?? 'draft',
          imageURL: this.servicesData.imageURL ?? '',
          contentsURL: encodeURI(this.servicesData.contentsURL.replace(/[\s\uFEFF\xA0]/g, '')) ?? '',
          checkHistories: this.servicesData.checkHistories ?? [],
          //サポート情報
          supportInfo: this.servicesData.supportInfo.map(info => ({
            mainCategoryName: info.mainCategoryName ?? '',
            subCategories: info.subCategories.map(sub => ({
              name: sub.name ?? '',
              description: sub.description ?? '',
              contactType: sub.contactType ?? '',
              contactInfo: sub.contactInfo.map(contact => ({
                method: contact.method ?? '',
                target: encodeURI(contact.target.replace(/[\s\uFEFF\xA0]/g, '')) ?? '',
              })),
            })),
          })),
          individualFlag: this.servicesData.individualFlag ?? false,
          individualInfo: {
            // edit画面でimageURL保存
            imageURL: this.servicesData.individualInfo.imageFile.file
              ? (this.servicesData.individualInfo.imageURL ?? '')
              : '',
            imageFile: this.servicesData.individualInfo.imageFile.binary ?? '',
            description: payload.individualInfo.description ?? '',
            htmlContentDesc: payload.individualInfo.htmlContentDesc ?? '',
            priceDescription: payload.individualInfo.priceDescription ?? '',
            htmlContentPrice: payload.individualInfo.htmlContentPrice ?? '',
            appWebviewFlag: this.servicesData.individualInfo.appWebviewFlag ?? false,
            appURL: encodeURI(this.servicesData.individualInfo.appURL.replace(/[\s\uFEFF\xA0]/g, '')) ?? '',
            appLoginFlag: this.servicesData.individualInfo.appLoginFlag ?? false,
            appCollaborationFlag: this.servicesData.individualInfo.appCollaborationFlag ?? false,
            customerWebviewFlag: this.servicesData.individualInfo.customerWebviewFlag ?? '',
            customerURL: encodeURI(this.servicesData.individualInfo.customerURL.replace(/[\s\uFEFF\xA0]/g, '')) ?? '',
            customerAccessFlag: this.servicesData.individualInfo.customerAccessFlag ?? false,
            features: this.servicesData.individualInfo.features.map(feature => ({
              imageURL: feature.imageFile.file ? (feature.imageURL ?? '') : '',
              imageFile: feature.imageFile.binary ?? '',
              description: feature.description ?? '',
            })),
            tabs: this.servicesData.individualInfo.tabs.map(tab => ({
              title: tab.title ?? '',
              flow: tab.flow.map(flow => ({
                imageURL: flow.imageFile.file ? (flow.imageURL ?? '') : '',
                imageFile: flow.imageFile.binary ?? '',
                description: flow.description ?? '',
              })),
            })),
            inquiry: {
              mainCategoryName: this.servicesData.individualInfo.inquiry.mainCategoryName ?? '',
              subCategories: this.servicesData.individualInfo.inquiry.subCategories.map(subCategory => ({
                name: subCategory.name ?? '',
                description: subCategory.description ?? '',
                contactType: subCategory.contactType ?? '',
                contactInfo: subCategory.contactInfo.map(contact => ({
                  method: contact.method ?? '',
                  target: encodeURI(contact.target.replace(/[\s\uFEFF\xA0]/g, '')) ?? '',
                })),
              })),
            },
          },
        };
        if (this.servicesData.individualFlag === false) {
          (formDataTmp.individualInfo.imageURL = ''),
            (formDataTmp.individualInfo.imageFile = ''),
            (formDataTmp.individualInfo.description = ''),
            (formDataTmp.individualInfo.htmlContentDesc = ''),
            (formDataTmp.individualInfo.priceDescription = ''),
            (formDataTmp.individualInfo.htmlContentPrice = ''),
            (formDataTmp.individualInfo.appWebviewFlag = false),
            (formDataTmp.individualInfo.appURL = ''),
            (formDataTmp.individualInfo.appLoginFlag = false),
            (formDataTmp.individualInfo.appCollaborationFlag = false),
            (formDataTmp.individualInfo.customerWebviewFlag = ''),
            (formDataTmp.individualInfo.customerURL = ''),
            (formDataTmp.individualInfo.customerAccessFlag = false),
            (formDataTmp.individualInfo.features = []),
            (formDataTmp.individualInfo.tabs = []),
            (formDataTmp.individualInfo.inquiry = {
              mainCategoryName: '',
              subCategories: [],
            });
        }
        if (this.servicesData.individualInfo.appLoginFlag === false) {
          formDataTmp.individualInfo.appCollaborationFlag = false;
        }
        await this.postRequest('/services/edit', formDataTmp).then(res => {
          if (res.status === 'success') {
            this.$router.push({ name: 'Services', query: { show: this.show } });
          } else {
            if (res.message) {
              this.showErrorModal(res.message);
            } else {
              this.showErrorModal(messageContent.requireTry('サービス更新'));
            }
          }
        });
      } else {
        this.showErrorModal(messageContent.requireTry('サービス更新'));
      }
    },
    handleUploadFileChangeImg(fileObj) {
      const vm = this;
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        function () {
          // eslint-disable-next-line no-unused-vars
          const [info, content] = reader.result.split(',');
          fileObj.binary = content;
        },
        false
      );
      if (fileObj.file[0]) {
        reader.readAsDataURL(fileObj.file[0]);
        fileObj.filename = fileObj.file[0].name;
        fileObj.size = fileObj.file[0].size;
        if (fileObj.filename !== null) {
          vm.agree = true;
        }
      } else {
        // clear file content
        fileObj.file = null;
        fileObj.filename = null;
        fileObj.binary = null;
        fileObj.size = null;
        vm.agree = false;
      }
    },
    handleUploadFileChange(type, file) {
      const reader = new FileReader();
      const data = this.servicesData[type];

      reader.addEventListener(
        'load',
        () => {
          // eslint-disable-next-line no-unused-vars
          const [info, content] = reader.result.split(',');
          data.binary = content;
        },
        false
      );

      if (file[0]) {
        reader.readAsDataURL(file[0]);
        data.filename = file[0].name;
        data.size = file[0].size;
        this.agree = type === 'imageFile' && data.filename !== null;
      } else {
        // Clear file content
        data.file = null;
        data.filename = null;
        data.binary = null;
        data.size = null;
        if (type === 'imageFile') {
          this.agree = false;
          this.servicesData.imageURL = '';
        }
      }
    },
    // サポートを追加する
    handleSupportAdd() {
      const maxSupportPageAdd = 3;
      if (this.servicesData.supportInfo.length < maxSupportPageAdd) {
        this.servicesData.supportInfo.push({
          mainCategoryName: '',
          subCategories: [
            {
              name: '',
              description: '',
              contactType: 'link',
              contactInfo: [
                {
                  target: '',
                  method: 'link',
                },
              ],
            },
          ],
        });
      } else {
        this.showErrorModal('大カテゴリには4つ以上のアイテムを追加できません。');
      }
    },
    // [個別ページ]お問い合わせを追加する
    handleInquiryAdd() {
      // inquiryFlag が true に設定されている場合は、新しいページを追加しないでください
      if (!this.servicesData.individualInfo.inquiryFlag) {
        this.servicesData.individualInfo.inquiryFlag = true;
      } else {
        this.showErrorModal('大カテゴリには2つ以上のアイテムを追加できません。');
      }
    },
    // [個別ページ]お問い合わせを削除する
    handleInquiryDelete() {
      // データの初期化
      this.servicesData.individualInfo.inquiry.mainCategoryName = '';
      this.servicesData.individualInfo.inquiry.subCategories = [
        {
          name: '', // 子カテゴリ名
          contactType: 'link',
          description: '', // 詳細
          contactInfo: [
            {
              method: 'link',
              target: '',
            },
          ],
        },
      ];
      // 表示フラグ変更
      this.servicesData.individualInfo.inquiryFlag = false;
    },
    // サポート削除する
    handleDeleteSupport(index) {
      // インデックスに対応する情報入力ページを削除します
      this.servicesData.supportInfo.splice(index, 1);

      // 残りの情報入力ページのインデックスを更新します。
      this.servicesData.supportInfo.forEach((support, i) => {
        // 子情報入力ページのインデックスを更新する
        support.subCategories.forEach(subCategory => {
          subCategory.index = i;
        });
      });
    },
    //　subカテゴリの追加する
    handleAddSubcategory(index) {
      const support = this.servicesData.supportInfo[index];
      if (support.subCategories.length < 5) {
        support.subCategories.push({
          name: '',
          description: '',
          contactType: 'link',
          contactInfo: [
            {
              method: 'mail',
              target: '',
            },
          ],
        });
      } else {
        this.showErrorModal('小カテゴリには6つ以上のアイテムを追加できません。');
      }
    },
    // subカテゴリを削除する
    handleDeleteSub(mainIndex, subIndex) {
      if (subIndex === 0) return;
      const support = this.servicesData.supportInfo[mainIndex];
      support.subCategories.splice(subIndex, 1);
    },
    // subメソードを削除する
    handleDeleteMethod(index, subCategoryIndex, methodIndex) {
      if (methodIndex === 0) return;
      const subCategory = this.servicesData.supportInfo[index].subCategories[subCategoryIndex];
      subCategory.contactInfo.splice(methodIndex, 1);
    },
    // subメソードを追加する
    handleAddMethod(subCategory) {
      if (subCategory.contactInfo.length < 2) {
        subCategory.contactInfo.push({
          method: 'mail',
          target: '',
        });
      } else {
        this.showErrorModal('お問い合わせ方法には3つ以上のアイテムを追加できません。');
      }
    },
    getPositionServicesList: function () {
      const data = {
        execUserID: this.execUserID,
      };
      return this.postRequest('/services/get-list', data).then(response => {
        let maxPosition = 0;
        const nowDate = utils.currentDateTime();
        for (const k in response.data) {
          const deleteDate = response.data[k].deleteDate;
          const checkStatus = response.data[k].checkStatus;
          if (checkStatus === 'approved' && deleteDate > nowDate) {
            maxPosition = Math.max(maxPosition, response.data[k].position);
          }
        }
        maxPosition++;
        this.maxPosition = maxPosition;
        return maxPosition;
      });
    },
    handleGetServicesInfo() {
      const nowDate = utils.currentDateTime();
      const id = this.$route.query.id;
      if (id) {
        this.postRequest('/services/get', { id })
          .then(e => {
            if (e.status === 'success' && e.data) {
              const data = e.data;
              const authInfo = this.$store.state.user.authInfo;
              console.log(data);
              if (authInfo === 'manager') {
                this.servicesData.serviceName1 = data?.serviceName1 || '';
                this.servicesData.serviceName2 = data?.serviceName2 || '';
                this.servicesData.abbreviatedName = data?.abbreviatedName || '';
                this.servicesData.bubbleComment = data?.bubbleComment || '';
                this.servicesData.serviceOverview = data?.serviceOverview || '';
                this.servicesData.imageURL = data?.imageURL || '';
                (this.servicesData.imageFile = {
                  file: e.data.imageURL ? e.data.imageURL : null,
                }),
                  (this.servicesData.homeBubbleFlag = data?.homeBubbleFlag || false);
                this.servicesData.homeBubbleComment = data?.homeBubbleComment || '';
                this.servicesData.castStartDate = data?.castStartDate || '';
                this.servicesData.castEndDate = data?.castEndDate || '';
                this.servicesData.webviewFlag = data?.webviewFlag || false;
                this.servicesData.bubbleFlag = data?.bubbleFlag || false;
                this.servicesData.contentsURL = decodeURI(data?.contentsURL) || '';
                // 個別ページ情報
                this.servicesData.individualFlag = data?.individualFlag || false;
                this.servicesData.individualFlagStr = data?.individualFlag ? 'need' : 'noneed';
                if (this.servicesData.individualFlag) {
                  this.servicesData.individualInfo.imageURL = data?.individualInfo.imageURL || '';
                  this.servicesData.individualInfo.imageFile = {
                    file: data?.individualInfo.imageURL !== '' ? data?.individualInfo.imageURL : null,
                  };
                  this.servicesData.individualInfo.description = data?.individualInfo.description || '';
                  if (data?.individualInfo.htmlContentDesc) {
                    this.servicesData.individualInfo.htmlContentDesc = data?.individualInfo?.htmlContentDesc;
                  } else {
                    // Note: 改行をpタグに統一してhtml化
                    this.servicesData.individualInfo.htmlContentDesc =
                      '<p>' + this.servicesData.individualInfo.description.replace(/\n/g, '</p><p>') + '</p>';
                  }
                  this.servicesData.individualInfo.priceDescription = data?.individualInfo.priceDescription || '';
                  if (data?.individualInfo.htmlContentPrice) {
                    this.servicesData.individualInfo.htmlContentPrice = data?.individualInfo.htmlContentPrice;
                  } else {
                    // Note: 改行をpタグに統一してhtml化
                    this.servicesData.individualInfo.htmlContentPrice =
                      '<p>' + this.servicesData.individualInfo.priceDescription.replace(/\n/g, '</p><p>') + '</p>';
                  }
                  this.se;
                  this.servicesData.individualInfo.appWebviewFlag = data?.individualInfo.appWebviewFlag || false;
                  this.servicesData.individualInfo.appURL = decodeURI(data?.individualInfo.appURL) || '';
                  this.servicesData.individualInfo.appLoginFlag = data?.individualInfo.appLoginFlag || false;
                  this.servicesData.individualInfo.appCollaborationFlag =
                    data?.individualInfo.appCollaborationFlag || false;
                  this.servicesData.individualInfo.customerWebviewFlag =
                    data?.individualInfo.customerWebviewFlag || false;
                  this.servicesData.individualInfo.customerURL = decodeURI(data?.individualInfo.customerURL) || '';
                  this.servicesData.individualInfo.customerAccessFlag =
                    data?.individualInfo.customerAccessFlag || false;
                  // 個別ページ特徴
                  this.servicesData.individualInfo.features =
                    data?.individualInfo.features.map(feature => ({
                      imageURL: feature.imageURL || '',
                      imageFile: {
                        file: feature.imageURL !== '' ? feature.imageURL : null,
                      },
                      description: feature.description || '',
                    })) || [];
                  // 個別ページ流れ
                  this.servicesData.individualInfo.tabs =
                    data?.individualInfo.tabs.map(tab => ({
                      title: tab.title || '',
                      flow:
                        tab.flow.map(f => ({
                          imageURL: f.imageURL || '',
                          imageFile: {
                            file: f.imageURL !== '' ? f.imageURL : null,
                          },
                          description: f.description || '',
                        })) || [],
                    })) || [];
                  this.servicesData.individualInfo.rightTabFlag = this.servicesData.individualInfo.tabs.length > 1;
                  // 個別ページ問い合わせ
                  this.servicesData.individualInfo.inquiry.mainCategoryName =
                    data?.individualInfo.inquiry.mainCategoryName || '';
                  this.servicesData.individualInfo.inquiry.subCategories =
                    data?.individualInfo.inquiry.subCategories.map(subCategory => ({
                      name: subCategory.name || '',
                      description: subCategory.description || '',
                      contactType: subCategory.contactType || 'link',
                      contactInfo:
                        subCategory.contactInfo.map(contact => ({
                          method: subCategory.contactType === 'link' ? 'link' : contact.method || '',
                          target: decodeURI(contact.target) || '',
                        })) || [],
                    })) || [];
                  this.servicesData.individualInfo.inquiryFlag =
                    this.servicesData.individualInfo.inquiry.mainCategoryName !== '' ||
                    this.servicesData.individualInfo.inquiry.subCategories.some(
                      subCategory =>
                        subCategory.name !== '' || subCategory.contactInfo.some(contact => contact.target !== '')
                    );
                }
                //サポート情報
                this.servicesData.supportInfo =
                  data?.supportInfo.map(support => ({
                    mainCategoryName: support.mainCategoryName || '',
                    subCategories: support.subCategories.map(subCategory => ({
                      name: subCategory.name || '',
                      description: subCategory.description || '',
                      contactType: subCategory.contactType || 'link',
                      contactInfo: subCategory.contactInfo.map(contact => ({
                        method: subCategory.contactType === 'link' ? 'link' : contact.method || '',
                        target: decodeURI(contact.target) || '',
                      })),
                    })),
                  })) || [];
                // 変更前の公開終了日時を保存
                this.beforeCastEndDate = data?.castEndDate || '';
                // 公開中の投稿か確認
                if (
                  data &&
                  data.checkStatus === 'approved' &&
                  data.castStartDate &&
                  data.castEndDate &&
                  data.castStartDate <= nowDate &&
                  nowDate <= data.castEndDate
                ) {
                  this.isPublished = true;
                  this.minDate = '';
                }

                if (this.isPublished) {
                  this.$router.push({ name: 'Services' });
                  return;
                }

                this.hasParentDoc = data?.parentDocId ? true : false;

                // DBに現在のcheckStatusを保存
                this.currentCheckStatus = data?.checkStatus;
                // 現在のcheckStatusの値しだいでvisibleCheckStatusOptionsを変更する
                this.visibleCheckStatusOptions = this.selectVisibleCheckStatusOptions(data?.checkStatus || '');
                // DBから取得したcheckHistoriesが空配列のときは更新せず、初期値のcampaignData.checkHistoriesを用いる
                if (data?.checkHistories && data?.checkHistories.length > 0) {
                  this.servicesData.checkHistories = data?.checkHistories;
                }
              } else {
                this.$router.push({ name: 'PermissionDenied' });
                return;
              }
            } else {
              this.showErrorModal(messageContent.requireTry('サービス取得'));
            }
          })
          .catch(error => {
            console.error(error);
            this.showErrorModal(messageContent.requireTry('サービス取得'));
          });
      }
    },
    handleCancelClick() {
      const id = this.id;
      const source = this.source;
      if (id && source === 'detail') {
        return this.$router.push({ name: 'ServicesDetail', query: { id: id, show: this.show } });
      } else {
        return this.$router.push({ name: 'Services', query: { show: this.show } });
      }
    },
    selectVisibleCheckStatusOptions(checkStatus) {
      if (checkStatus === 'draft') {
        return [
          { value: 'draft', label: '下書き' },
          { value: 'checked', label: 'チェック済み' },
        ];
      } else if (checkStatus === 'checked') {
        return [
          { value: 'draft', label: '下書き' },
          { value: 'approved', label: '承認済み' },
        ];
      } else if (checkStatus === 'approved') {
        return [{ value: 'draft', label: '下書き' }];
      }
      // イレギュラーは下書き相当
      return [
        { value: 'draft', label: '下書き' },
        { value: 'checked', label: 'チェック済み' },
      ];
    },
    backPageName() {
      const source = this.source;
      if (source === 'detail') {
        return '詳細画面';
      } else {
        return '一覧画面';
      }
    },
    backPage() {
      const source = this.source;
      if (source === 'detail') {
        return 'ServicesDetail';
      } else {
        return 'Services';
      }
    },
    // [個別ページ]featureを追加する
    handleAddFeature() {
      if (this.servicesData.individualInfo.features.length < 5) {
        this.servicesData.individualInfo.features.push({
          imageURL: '',
          imageFile: {
            file: null,
            filename: null,
            binary: null,
            size: null,
          },
          description: '',
        });
      } else {
        this.showErrorModal('サービスの特徴には6つ以上のアイテムを追加できません。');
      }
    },
    // [個別ページ]featureを削除する
    handleDeleteFeature(index) {
      if (index === 0) return;
      this.servicesData.individualInfo.features.splice(index, 1);
    },

    // [個別ページ]flowを追加する
    handleAddFlow(tabIndex) {
      if (this.servicesData.individualInfo.tabs[tabIndex].flow.length < 10) {
        this.servicesData.individualInfo.tabs[tabIndex].flow.push({
          imageURL: '',
          imageFile: {
            file: null,
            filename: null,
            binary: null,
            size: null,
          },
          description: '',
        });
      } else {
        this.showErrorModal('ご利用の流れには11以上のアイテムを追加できません。');
      }
    },
    // [個別ページ]flowを削除する
    handleDeleteFlow(tabIndex, index) {
      if (index === 0) return;
      this.servicesData.individualInfo.tabs[tabIndex].flow.splice(index, 1);
    },
    // [個別ページ]右設置タブの有無を制御する
    handleRightTabFlag() {
      if (this.servicesData.individualInfo.rightTabFlag) {
        this.servicesData.individualInfo.tabs[1] = {
          title: '',
          flow: [
            {
              imageURL: '',
              imageFile: {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
              description: '',
            },
          ],
        };
      } else {
        this.servicesData.individualInfo.tabs.splice(1, 1);
      }
    },
    //　[個別ページ]お問い合わせsubカテゴリ追加
    handleAddSubForInquiry() {
      const inquiry = this.servicesData.individualInfo.inquiry;
      if (inquiry.subCategories.length < 5) {
        inquiry.subCategories.push({
          name: '',
          description: '',
          contactType: 'link',
          contactInfo: [
            {
              method: 'mail',
              target: '',
            },
          ],
        });
      } else {
        this.showErrorModal('小カテゴリには6つ以上のアイテムを追加できません。');
      }
    },
    // [個別ページ]お問い合わせsubカテゴリ削除
    handleDeleteSubForInquiry(subIndex) {
      if (subIndex === 0) return;
      const inquiry = this.servicesData.individualInfo.inquiry;
      inquiry.subCategories.splice(subIndex, 1);
    },
    // [個別ページ]お問い合わせsubメソッド追加
    handleAddMethodForInquiry(subCategory) {
      if (subCategory.contactInfo.length < 2) {
        subCategory.contactInfo.push({
          method: 'mail',
          target: '',
        });
      } else {
        this.showErrorModal('お問い合わせ方法には3つ以上のアイテムを追加できません。');
      }
    },
    // [個別ページ]お問い合わせsubメソッド削除
    handleDeleteMethodForInquiry(subCategoryIndex, methodIndex) {
      if (methodIndex === 0) return;
      const subCategory = this.servicesData.individualInfo.inquiry.subCategories[subCategoryIndex];
      subCategory.contactInfo.splice(methodIndex, 1);
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
  },
};
</script>
